import { ISearchBox } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";
import { Ifilter } from "../../../../Interfaces/filter";
import { IIncidenteDTO } from "../../../../Interfaces/hazard/IHazard";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";
import { GrupoIncidenteService } from "../../../../services/hazard/grupoIncidente";

export const UseIncidenteTable=()=>{
const [loading, setLoading] = useState<boolean>(false)
  const [items, setItems] = useState<IIncidenteDTO[]>([])
  const [control, setControl] = useState(true)
  const onChangeSearch = useRef<ISearchBox>(null);
  const [filter, setFilter] = useState<Ifilter>({
    skip: 0,
    take: 50,
  });
  const initial: Ifilter = {
    skip: 0,
    take: 50,
  }
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const onChangeTake = (value: number) => {
    setFilter({ ...filter, take: value })
    setControl(true)
  };
  const onSkip = (value: number) => {
    const realSkip = (value * filter.take) - filter.take
    setFilter({ ...filter, skip: realSkip })
    setControl(true)
  };

  const handleResetUpdate = () => {
    setFilter(initial);
    setControl(true)
  };
  const getIncidentes=()=>{
    setLoading(true)
    GrupoIncidenteService.ListarGrupoIncidente(filter).then((res) => {
      const pag: IPaginationV2 = {
        currentPage: res.data.page,
        total: res.data.total,
        pageSize: res.data.pages,
        onPageChange: onSkip,
        skip: filter.skip,
        take: filter.take,
        onSizeChange: onChangeTake
      };
      setPagination(pag)
      setLoading(false)
      setItems(res.data.items)
    }).catch((e: any) => {
      setLoading(false)
    })
  }
  const [pagination, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {
    },
    onSizeChange: function (value: number): void {
    }
  })
  useEffect(() => {
    if (control) {
      getIncidentes();
      setControl(false);
    }
  }, [control, filter]);
  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    getIncidentes,
    handleResetUpdate,
    onChangeTake,
    _onkeyUpSearchTable,
    onChangeSearch
  }
}